/*
 * @Author: your name
 * @Date: 2021-06-07 20:40:40
 * @LastEditTime: 2021-06-23 20:52:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/config/module/modal/finance.config.js
 */
// 财务中心
export default {
  SG_B_DISTRIBUTION_ORDER_SPLIT: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/splitOrderModal.vue'
    ),
  },
  SG_B_DISTRIBUTION_ORDER_SPLITBYSKU: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/specifyGoodsAssignSku.vue'
    ),
  },
  ADJUSTMENT_DEDUCTION: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/ADJUSTMENT_DEDUCTION.vue'
    ),
  },
  // 销售数据记录中间表 - 手工新增
  ADD_MANUALLY: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/ADD_MANUALLY.vue'
    ),
  },
  // 唯品会进度账单 唯品会月结账单列表 (下载账单)
  DOWNLOADVIPBILL: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/downLoadVipBill.vue'
    ),
  },
  // 唯品会进度账单聚合表列表 唯品会月结账单聚合表列表 (生成销售单)
  GENERATESALESORDER: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/generateSalesOrder.vue'
    ),
  },
  // 支付宝下载账单
  DOWNLOADALIPAYBILL: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/downLoadAlipayBill.vue'
      ),
  },
  AUTHORIZE:{
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/authorize.vue'
    ),
  },
  // 原始账单导入记录 - 账单导入
  ACFCONFIRMPLATFORMBILLIMPORT: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/douyinBillImport.vue'
    )
  },
  // 物流费用对账单 - 调拨费用分摊
  ALLOCATION_OF_TRANSFER_EXPENSES: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/dBCostSharing.vue'
    )
  },
  // 零担报价设置、快递报价设置、快运报价设置 - 重新计算
  RECALCULATE_LOGISTICS: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/dBCostSharing.vue'
    )
  },
  // 发票单管理-换票
  CHANGE_TICKETS: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/creatInvoice.vue'
    )
  },
  // 发票单管理- 查看发票
  INVOICE_VIEW: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/viewInvoice.vue'
      )
  },
  // 月结汇总单- 月结汇总
  MONTHLY_SUM: {
    component: () => import(
      /* webpackChunkName: 'FinanceCenterModal' */
      '@/views/modal/financeCenter/monthlySum.vue'
      )
  },
};
